type Props = { body: string; title: string };

export const AssignedUsersToast: React.FC<Props> = ({ body, title }) => (
    <div className="flex flex-col">
        <span className="font-medium">{title}</span>
        <span>{body}</span>
    </div>
);
